import { Module } from 'core/Module';
import { Events } from 'core/events/Events';
import { AppEvents } from 'app/events/AppEvents';
import DelayHelper from 'utils/timers';
import { Simple } from 'utils/analytics';

export class Expandable extends Module {
	public config = {
		target: null
	};

	private $more;
	private expanded = false;

	public create(): void {
		this.$more = this.$container.querySelector('.expandable-more');
		this.$container.querySelector('.expandable-preview');

		Events.on('click', this.$more, (e) => {
			e.preventDefault();

			this.expanded = !this.expanded;

			if (this.expanded) {
				this.DOM.addClass(this.$container, '-expanded');
				let type = (e.target as HTMLElement).dataset.type || 'not_set';
				Simple.event('project_more_open', { type: type });
			} else {
				this.DOM.removeClass(this.$container, '-expanded');
			}

			DelayHelper.setTimeout(() => {
				Events.dispatch(AppEvents.APP_RESIZE);
			}, 550);
		});
	}

	public resize(sizes: any): void {
	}
}
